import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/defaultGraph.png'


const _withScopeId = n => (_pushScopeId("data-v-2df20bc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "white-page" }
const _hoisted_2 = {
  key: 0,
  class: "tip default-graph"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "default-graph-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 缺少活动参数 ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "tip default-graph"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "default-graph-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "活动未开始", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "tip"
}
const _hoisted_11 = {
  key: 3,
  class: "tip default-graph"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "txt",
  style: {'color': '#656565'}
}, "数据加载中...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_loading = _resolveComponent("van-loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.route.query.actId || !_ctx.route.query.sourceDetail)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_5))
      : (_ctx.activityInfo.actStatus === 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_9))
        : (_ctx.activityInfo.actStatus === 2)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, " 活动已结束 "))
          : (_ctx.activityInfo.actStatus === -1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _createVNode(_component_van_loading, {
                  class: "loading-box",
                  type: "spinner",
                  size: "50px",
                  vertical: "",
                  color: _ctx.activityInfo.subjectRgb
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["color"])
              ]))
            : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, _ctx.activityInfo.actStatus !== 1]
  ])
}